import { useQuery } from '@tanstack/vue-query'
import { supportKeys } from '../supportQueryKeys'
import { getTicketCategories } from '../supportEndpoints'
import { parseTicketCategories } from '../parsers/supportTicketParser'
import { TICKET_CATEGORIES_STALE_MS } from '../../constants/supportTickets'

// Seller ticket categories for the create form — signed-in dialog and the
// public contact page alike.
export function useTicketCategoriesQuery() {
  return useQuery({
    queryKey: supportKeys.ticketCategories(),
    queryFn: () => getTicketCategories().then(parseTicketCategories),
    staleTime: TICKET_CATEGORIES_STALE_MS,
  })
}
